export class TemplatePeriodAccumulationType {
	constructor() {
	}
} 
